<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content content-with-nav pa-0"
    fluid
  >
    <!-- Hero section -->
    <page-hero title="Praktische afspraken" />

    <!-- Content -->
    <v-row justify="center">
      <v-col
        class="center"
        cols="12"
        md="8"
        lg="6"
      >
        <ul class="afspraken-list">
          <li>
            Om onszelf de kans te geven alles keurig in orde te zetten voor de plechtigheid en nog een laatste keer te controleren, worden de deuren maar pas een half uur voor de aanvang van de plechtigheid geopend, ook voor de dichtste familie. U mag gerust vroeger komen, maar dan verzoeken wij u beleefd om nog even te wachten. De andere mensen worden een kwartier voor aanvang verwacht.
          </li>
          <li>
            Mensen die een tekst lezen, brengen deze zelf mee.
          </li>
          <li>
            Als er mensen wiens naam in het welkomstwoord vermeld wordt, afwezig zijn, gelieve dit dan bij aankomst te vermelden.
          </li>
          <li>
            Het condoleancemoment vindt vóór de plechtigheid plaats en indien er een koffietafel is die aansluit op de plechtigheid, neemt de familie meteen plaats in de koffiezaal.
          </li>
          <li>
            Jassen mogen aan de kapstok worden gehangen.
          </li>
        </ul>
        <p class="afspraken-closing mt-6">
          Voor verdere vragen of opmerkingen, mag u ons steeds contacteren.
          We hopen er samen met u een mooie plechtigheid van te maken.
        </p>
        <p class="afspraken-signature mt-4">
          Met vriendelijke groeten,
          <br>
          Team Verstappen
        </p>
      </v-col>
    </v-row>

    <!-- Navigation -->
    <div class="samenstellen-nav">
      <div class="samenstellen-nav-inner">
        <v-btn
          v-if="samenstellenNavigation_PreviousItem"
          color="primary"
          :disabled="samenstellenNavigation_PreviousItem.disabled"
          rounded
          variant="text"
          @click="samenstellenNavigation_GoToPrevious"
        >
          <v-icon start>
            mdi-chevron-left
          </v-icon>
          {{ samenstellenNavigation_PreviousItem.title }}
        </v-btn>
        <span v-else />
        <v-btn
          v-if="samenstellenNavigation_NextItem"
          color="primary"
          :disabled="samenstellenNavigation_NextItem.disabled"
          rounded
          variant="text"
          @click="samenstellenNavigation_GoToNext"
        >
          {{ samenstellenNavigation_NextItem.title }}
          <v-icon end>
            mdi-chevron-right
          </v-icon>
        </v-btn>
        <span v-else />
      </div>
    </div>
  </v-container>
</template>

<script>
import PageHero from '@/components/PageHero.vue'
import authenticationMixin from '@/mixins/authenticationMixin'
import samenstellenNavigationMixin from '@/mixins/samenstellenNavigationMixin'

export default {
  name: 'PraktischeAfsprakenComponent',
  components: {
    PageHero
  },
  mixins: [
    authenticationMixin,
    samenstellenNavigationMixin
  ],
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    this.$store.state.headers.samenstellen = true
  },
  beforeUnmount () {
    this.$store.state.headers.samenstellen = false
  }
}
</script>

<style scoped>
.afspraken-list {
  font-size: 15px;
  color: #424E58;
  line-height: 1.7;
  padding-left: 20px;
}

.afspraken-list li {
  margin-bottom: 16px;
}

.afspraken-closing {
  font-size: 15px;
  color: #424E58;
  line-height: 1.7;
  padding: 0;
}

.afspraken-signature {
  font-size: 15px;
  font-weight: 500;
  color: #907322;
  padding: 0;
}
</style>
